// ScrollSpy Plugin v0.0.1 for jQuery
// =============
// Author: Denis Lyashkov
// Created: 03/11/2015
// Date: 03/11/2015
// Website:
// Description: Scroll spying for highlighting current viewed section
jQuery.fn.scrollspy = function(params)
{
	var instance = init(this, params);
	$.fn.scrollspy.instances.push(instance);
	return instance;

	function init(el, params){
		var current_section;
		var defaults = {
			container_selector: el || 'body',
			section_selector: '.scrollspy-section',
			onChangeActive: function(el){
				return el;
			},
			triggerDistance: 100
		};
		var options = $.extend({}, defaults, params);

		this.is_enabled = false;
		this.is_paused = false;
		var _this = this;

		this.enable = function(){
			$(options.container_selector).on('scroll.spy', function(){
				$(options.section_selector).each(function(index, value){
					var el = this;
					if($.inViewport(el, options.triggerDistance)){
						if(current_section !== index){
							current_section = index;
							if(options.onChangeActive){
								options.onChangeActive.call(this, el);
							}
						}
						return false; // break;
					}
				});
			});
			_this.is_enabled = true;
		};
		this.disable = function(){
			$(options.container_selector).off('scroll.spy');
			_this.is_enabled = false;
		};

		// �������� scroll listener
		this.enable();

		return this;
	}
};
jQuery.fn.scrollspy.instances = [];
jQuery.fn.scrollspy.pause = function(){
	$.each(jQuery.fn.scrollspy.instances, function(i, value){
		if(value.is_enabled){
			value.disable();
			value.is_paused = true;
		}
	});
};
jQuery.fn.scrollspy.start = function(){
	$.each(jQuery.fn.scrollspy.instances, function(i, value){
		if(!value.is_enabled && value.is_paused){
			value.enable();
			value.is_paused = false;
		}
	});
};
